//船务信息服务费

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 状态
 */
class State extends UltMeta {
    UNPAID = new Meta(1, "待支付");
    UN_CONFIRM = new Meta(2, "待确认");
    SUCCESS = new Meta(3, "已支付");
}

export const STATE = new State();

/**
 * 类型
 */
class Type extends UltMeta {
    OWNER = new Meta(1, "货主");
    CAPTAIN = new Meta(2, "船主");
}

export const TYPE = new Type();

/**
 * 支付类型
 */
class PayType extends UltMeta {
    ONLINE = new Meta(1, "线上");
    OFFLINE = new Meta(2, "线下");
}

export const PAY_TYPE = new PayType();
